<div class="page">
  <div class="404texts text-center">
    <h5 class="mb-5">
      Oops! Looks like we've lost this page in the digital jungle. 🕵️‍♂️
    </h5>
    <img src="../../../../assets/img/common/404error.gif" alt="comingSoon" />
    <button
      (click)="navigateToHome()"
      class="ti-button-outline ti-btn-primary-fill"
    >
      Go to Home
    </button>
  </div>
</div>
